export const maintenance = () => false;
export default maintenance();
